export const CONFIG = {
	site: {
		basePath: process.env.NEXT_PUBLIC_WEB_PATH ?? "",
	},
};
